import intermind, { ListConfig, ListParams, ListResponse } from '../../../index';
import { Prompt, PromptCreateDto, PromptUpdateDto } from '../types/prompt.types';

export class PromptResource {
  async createPrompt(dto: PromptCreateDto): Promise<Prompt> {
    const { data } = await intermind.httpClient.post<Prompt>(`/ai/prompts`, dto);
    return data;
  }

  async updatePrompt(id: string, dto: PromptUpdateDto): Promise<Prompt> {
    const { data } = await intermind.httpClient.put<Prompt>(`/ai/prompts/${id}`, dto);
    return data;
  }

  async deletePrompt(id: string): Promise<void> {
    await intermind.httpClient.delete(`/ai/prompts/${id}`);
  }

  async listPredefinedPrompts(params?: ListParams): Promise<ListResponse<Prompt>> {
    const { data } = await intermind.httpClient.get<ListResponse<Prompt>>(`/ai/prompts/predefined`, { params });
    return data;
  }

  async listCustomPrompts(params?: ListParams): Promise<ListResponse<Prompt>> {
    const { data } = await intermind.httpClient.get<ListResponse<Prompt>>(`/ai/prompts/custom`, { params });
    return data;
  }

  async getPromptListConfig(): Promise<ListConfig> {
    const { data } = await intermind.httpClient.get(`/ai/prompts/list-config`);
    return data;
  }
}
